export default __webpack_public_path__ + "beed25f.png";